import React from 'react';
import { icon } from './button-icon.css';
import { cn } from '~/utils';
const componentId = 'vulcanui-button-icon';
function Icon({ children }) {
    return React.createElement("span", { className: cn(componentId, icon) }, children);
}
Icon.displayName = 'ButtonIcon';
Icon.toString = () => `.${componentId}`;
export default Icon;
//# sourceMappingURL=button-icon.js.map